/* Swiper
 **************************************************************/
var swiper = Swiper;
var init = false;
document.addEventListener("DOMContentLoaded", function () {
  const keyMarketsComponent = document.querySelector(".key-markets__markets");

  if (keyMarketsComponent) {
    let smallDesktop = window.matchMedia(
      "(min-width: 0px) and (max-width: 1199.98px)"
    );
    let aboveSmallDesktop = window.matchMedia("(min-width: 1200px)");

    function swiperMode() {
      // Enable (for smallDesktop)
      if (smallDesktop.matches) {
        if (!init) {
          init = true;
          swiper = new Swiper(".key-markets__markets", {
            direction: "horizontal",
            loop: true,
            // TODO: needed?
            // effect: "slide",
            // TODO: speed and autoplay?
            speed: 1000,
            slidesPerView: "auto",
            spaceBetween: 54,
            grabCursor: false,
            breakpoints: {
              992: {
                spaceBetween: 62,
              },
            },
          });
        }
        // Disable (for aboveSmallDesktop)
      } else if (aboveSmallDesktop.matches) {
        if (swiper.destroy) {
          swiper.destroy();
          init = false;
        }
      }
    }

    /* On Load
     **************************************************************/
    swiperMode();

    /* On Resize
     **************************************************************/
    window.addEventListener(
      "resize",
      debounce(function () {
        swiperMode();
      }, 250)
    );
  }
});
